import { createCrmEnrichmentAPIService } from "app/pages/sales-intelligence/modules/crm-enrichment/services/api/factory";
import defaultFetchServiceOverride from "app/common/services/salesFetchService";

const hubspotEnrichmentAPIService = createCrmEnrichmentAPIService(defaultFetchServiceOverride, "hubspot");

export default hubspotEnrichmentAPIService;
